import { cn, Stack } from '@crossnokaye/ux-common';

interface FacilityFrameProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const FacilityFrame = ({ children, className, ...props }: FacilityFrameProps) => {
  return (
    <Stack gap="none" className={cn('@container/facility h-full relative', className)} {...props}>
      {children}
    </Stack>
  );
};
